

class ActionResultEvents {
    static HISTORY_READY = Symbol("HISTORY_READY");
    static SERVER_ERROR = Symbol("SERVER_ERROR");

    static SESSION_CREATED = Symbol("SESSION_CREATED");
    static INVALID_SESSION = Symbol("INVALID_SESSION");
    static FB_LOGIN_FAILED = Symbol("FB_LOGIN_FAILED");
    static FB_LOGOUT_SUCCESS = Symbol("FB_LOGOUT_SUCCESS");
    static MEMBER_LOADED = Symbol("MEMBER_LOADED");
    static PROFILE_LOADED = Symbol("PROFILE_LOADED");
    static SPACE_OWNER_SHAREABLE_PROFILE_LOADED = Symbol("SPACE_OWNER_SHAREABLE_PROFILE_LOADED");
    static ADVERTISEMENT_OWNER_SHAREABLE_PROFILE_LOADED = Symbol("ADVERTISEMENT_OWNER_SHAREABLE_PROFILE_LOADED");
    static SHAREABLE_PROFILE_UNAUTHORIZED = Symbol("SHAREABLE_PROFILE_UNAUTHORIZED");
    static GOOGLE_LIB_LOADED = Symbol("GOOGLE_LIB_LOADED");
    static PROFILE_CREATE_NON_UNIQUE_DISPLAY_NAME = Symbol("PROFILE_CREATE_NON_UNIQUE_DISPLAY_NAME");
    static PROFILE_CREATE_NON_UNIQUE_EMAIL = Symbol("PROFILE_CREATE_NON_UNIQUE_EMAIL");
    static PROFILE_CREATED = Symbol("PROFILE_CREATED");
    static PROFILE_EDITED = Symbol("PROFILE_EDITED");
    static FIND_SPACE_LOADED = Symbol("FIND_SPACE_LOADED");
    static INVALID_SEARCH_QUERY = Symbol("INVALID_SEARCH_QUERY");

    static PUBLIC_SPACE_NOT_FOUND = Symbol("PUBLIC_SPACE_NOT_FOUND");
    static PRIVATE_SPACE_DETAILS_NOT_FOUND = Symbol("PRIVATE_SPACE_DETAILS_NOT_FOUND");
    static PUBLIC_SPACE_LOADED = Symbol("PUBLIC_SPACE_LOADED");
    static PRIVATE_SPACE_DETAILS_LOADED = Symbol("PRIVATE_SPACE_DETAILS_LOADED");

    static PRIVATE_SPACE_NOT_FOUND = Symbol("PRIVATE_SPACE_NOT_FOUND");
    static PRIVATE_SPACE_LOADED = Symbol("PRIVATE_SPACE_LOADED");

    static EMAIL_VERIFICATION_EMAIL_SENT = Symbol("EMAIL_VERIFICATION_EMAIL_SENT");
    static EMAIL_VERIFICATION_SUCCESS = Symbol("EMAIL_VERIFICATION_SUCCESS");
    static EMAIL_VERIFICATION_INVALID_CODE = Symbol("EMAIL_VERIFICATION_INVALID_CODE");

    static PHONE_NUMBER_VERIFICATION_SMS_SENT = Symbol("PHONE_NUMBER_VERIFICATION_SMS_SENT");
    static PHONE_NUMBER_VERIFICATION_SUCCESS = Symbol("PHONE_NUMBER_VERIFICATION_SUCCESS");
    static PHONE_NUMBER_VERIFICATION_INVALID_CODE = Symbol("PHONE_NUMBER_VERIFICATION_INVALID_CODE");

    static LISTED_SPACES_LOADED = Symbol("LISTED_SPACES_LOADED");
    static UNLISTED_SPACES_LOADED = Symbol("UNLISTED_SPACES_LOADED");
    static MY_SPACES_LOADED = Symbol("MY_SPACES_LOADED");

    static SPACE_CREATED = Symbol("SPACE_CREATED");
    static ADVERTISEMENT_CREATED = Symbol("ADVERTISEMENT_CREATED");
    static MY_ADVERTISEMENTS_LOADED = Symbol("MY_ADVERTISEMENTS_LOADED");
    static ADVERTISEMENT_LOADED = Symbol("ADVERTISEMENT_LOADED");

    static ADVERTISEMENT_BILLING_LOADED = Symbol("ADVERTISEMENT_BILLING_LOADED");
    static SPACE_BALANCE_LOADED = Symbol("SPACE_BALANCE_LOADED");

    static IMAGE_UPLOAD_URL_CREATED = Symbol("IMAGE_UPLOAD_URL_CREATED");
    static IMAGE_UPLOAD_FINISHED = Symbol("IMAGE_UPLOAD_FINISHED");

    static SPACE_EDITED = Symbol("SPACE_EDITED");
    static SPACE_UNLISTED = Symbol("SPACE_UNLISTED");
    static SPACE_LISTED = Symbol("SPACE_LISTED");
    static MEMBER_SPACE_CALENDAR_LOADED = Symbol("MEMBER_SPACE_CALENDAR_LOADED");
    static UNAVAILABLE_SPACE_CALENDAR_LOADED = Symbol("UNAVAILABLE_SPACE_CALENDAR_LOADED");

    static ADVERTISEMENT_EDITED = Symbol("ADVERTISEMENT_EDITED");
    static MEMBER_SPACES_RESERVATIONS_LOADED = Symbol("MEMBER_SPACES_RESERVATIONS_LOADED");
    static MEMBER_ADVERTISEMENT_RESERVATIONS_LOADED = Symbol("MEMBER_ADVERTISEMENT_RESERVATIONS_LOADED");
    static SPACE_REJECTED = Symbol("SPACE_REJECTED");
    static RESERVATION_REQUEST_CREATED_SUCCESSFULLY = Symbol("RESERVATION_REQUEST_CREATED_SUCCESSFULLY");
    static CHECKOUT_SESSION_CREATED = Symbol("CHECKOUT_SESSION_CREATED");
    static CHECKOUT_PAYMENT_FAILED = Symbol("CHECKOUT_PAYMENT_FAILED");
    static CHECKOUT_PAYMENT_SUCCESS = Symbol("CHECKOUT_PAYMENT_SUCCESS");
    static PROFILE_EDIT_NON_UNIQUE_DISPLAY_NAME = Symbol("PROFILE_EDIT_NON_UNIQUE_DISPLAY_NAME");
    static PROFILE_EDIT_NON_UNIQUE_EMAIL = Symbol("PROFILE_EDIT_NON_UNIQUE_EMAIL");

}

export default ActionResultEvents;
